import React, { useState } from "react";
import { IconButton, Menu, Tooltip, Divider } from "@mui/material";
import { HelpOutlineRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { CACHE_VERSION } from "config/version";

/**
 * "?" Help / About menu — app version + light info. No external docs yet.
 */
const HelpMenu = () => {
  const { t } = useTranslation(["common"]);
  const [anchor, setAnchor] = useState(null);

  return (
    <>
      <Tooltip title={t("help", "Help")}>
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)} sx={{ color: "var(--gray-color)" }}>
          <HelpOutlineRounded />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{ sx: { width: 260 } }}
      >
        <div className="px-4 py-3">
          <div className="text-[14px] font-semibold text-slate-700">ERP System</div>
          <div className="text-[12px] text-slate-400 mt-0.5">
            {t("version", "Version")} {CACHE_VERSION}
          </div>
        </div>
        <Divider />
        <div className="px-4 py-3 text-[12px] text-slate-500">
          <div className="mb-1">
            <span className="font-semibold">Ctrl/⌘ + K</span> — {t("searchPlaceholder", "Search")}
          </div>
          <div>{t("supportLine", "For support, contact your administrator.")}</div>
        </div>
      </Menu>
    </>
  );
};

export default HelpMenu;
